// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__irIYz","modalBody":"MealsPop_modalBody__XEvsl"};